module.exports = __webpack_public_path__ + "img/new-treatment-modal-desktop-fr.bb8c15d0.jpg";